import { Link } from "react-router-dom";
import { BRAND } from "../../brand";
import { ArrowRight, MessageCircle, Inbox, Bot, Users, Boxes } from "lucide-react";

const points = [
  { icon: Inbox, t: "Bandeja unificada", d: "WhatsApp Business API, IG DM, FB Messenger, web chat, email y SMS en un solo lugar." },
  { icon: Bot, t: "IA conversacional nativa", d: "Agentes IA + reglas de negocio + escalamiento humano cuando hace falta." },
  { icon: Users, t: "Atribución de ventas", d: "Cada conversación atada a campañas y agentes para medir ROAS real." },
  { icon: Boxes, t: "Integraciones empresariales", d: "Webhooks, CRM, ecommerce, billing y APIs internas. Production-ready." },
];

export default function RespondIO() {
  return (
    <section id="respond" data-testid="respond-io-section" className="relative py-24 sm:py-32">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {/* Visual */}
          <div className="lg:col-span-6 order-2 lg:order-1 reveal">
            <div className="relative">
              <div className="absolute -inset-8 bg-gradient-to-tr from-[#ff8a00]/25 via-[#ff3b1f]/15 to-transparent blur-3xl" />
              <div className="relative grad-border overflow-hidden">
                <div className="px-5 py-3 flex items-center gap-2 border-b border-white/10 bg-black/40">
                  <span className="w-2.5 h-2.5 rounded-full bg-red-500/70" />
                  <span className="w-2.5 h-2.5 rounded-full bg-yellow-500/70" />
                  <span className="w-2.5 h-2.5 rounded-full bg-green-500/70" />
                  <span className="ml-3 text-[11px] tracking-widest uppercase text-zinc-500">respond.io · panel</span>
                </div>
                <div className="grid grid-cols-12 gap-0">
                  <div className="col-span-4 border-r border-white/10 p-3 space-y-2">
                    {[
                      { n: "Andrea M.", c: "WhatsApp", m: "Quiero info..." },
                      { n: "Carlos R.", c: "Instagram", m: "¿Precio del..." },
                      { n: "Lucía P.", c: "Web Chat", m: "Necesito demo" },
                      { n: "Equipo BD", c: "Email", m: "Propuesta v3" },
                    ].map((row, i) => (
                      <div key={i} className={`p-2.5 rounded-lg ${i === 0 ? "bg-white/[0.05] border border-white/10" : "hover:bg-white/[0.03]"}`}>
                        <div className="flex items-center justify-between">
                          <span className="text-white text-[12px] font-display font-semibold truncate">{row.n}</span>
                          <span className="text-[9px] text-[#ff8a00] tracking-widest uppercase">{row.c}</span>
                        </div>
                        <div className="text-[11px] text-zinc-500 truncate">{row.m}</div>
                      </div>
                    ))}
                  </div>
                  <div className="col-span-8 p-4 space-y-2">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-8 h-8 rounded-full bg-gradient-brand" />
                      <div>
                        <div className="text-white text-[13px] font-display font-semibold">Andrea Martínez</div>
                        <div className="text-[10px] text-zinc-500">WhatsApp · Calificada · ROAS atribuido</div>
                      </div>
                    </div>
                    <div className="bg-white/[0.04] border border-white/10 rounded-lg p-3 text-[12px] text-zinc-300">Hola, vi el anuncio en Instagram, ¿manejan empresas de 50+ empleados?</div>
                    <div className="bg-gradient-brand text-black rounded-lg p-3 text-[12px] ml-10">Sí, exactamente nuestro segmento. Te agendo demo con un especialista para mañana 10:30 AM. ¿Confirmamos?</div>
                    <div className="bg-white/[0.04] border border-white/10 rounded-lg p-3 text-[12px] text-zinc-300">Confirmado, gracias.</div>
                    <div className="mt-2 grid grid-cols-3 gap-2">
                      <Pill>Etiqueta: Hot</Pill>
                      <Pill>Agendado</Pill>
                      <Pill>CRM ✓</Pill>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-6 order-1 lg:order-2 reveal">
            <div className="eyebrow mb-5">Partner de implementación · Respond.io</div>
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl tracking-tighter leading-[1.05]">
              Centraliza tus canales y <span className="text-gradient">deja de perder leads</span>.
            </h2>
            <p className="mt-6 text-zinc-400 text-lg max-w-xl">
              Implemento Respond.io de extremo a extremo: integraciones, automatizaciones, IA conversacional, reportes y entrenamiento al equipo.
              Tu operación deja de depender de cinco bandejas distintas.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-3">
              {points.map(({ icon: Icon, t, d }) => (
                <div key={t} className="glass rounded-xl p-4 flex gap-3">
                  <Icon className="w-5 h-5 text-[#ff8a00] mt-0.5 shrink-0" />
                  <div>
                    <div className="text-white font-display font-semibold text-sm">{t}</div>
                    <div className="text-zinc-400 text-[13px] leading-relaxed mt-1">{d}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={BRAND.respondAffiliate}
                target="_blank"
                rel="noreferrer"
                className="btn-primary"
                data-testid="respond-affiliate-cta"
              >
                <MessageCircle className="w-4 h-4" />
                Conocer Respond.io
                <ArrowRight className="w-4 h-4" />
              </a>
              <Link to="/contacto" className="btn-secondary" data-testid="respond-implementation-cta">
                Quiero que lo implementes
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Pill({ children }) {
  return (
    <div className="text-[10px] tracking-widest uppercase text-[#ff8a00] glass rounded-md py-1.5 text-center">
      {children}
    </div>
  );
}
